export const environment = {
  production: false,
  cognito: {
    userPoolId: 'us-east-2_bRJLMjaw4',
    userPoolRegion: 'us-east-2',
    clientId: '1rt9dlcvqji0hk1cur5vmfm6ra',
    // Note: clientSecret removed - PKCE is used for public client authentication
    domain: 'us-east-2brjlmjaw4.auth.us-east-2.amazoncognito.com',
    redirectUri: 'https://app-dev.kaizenic.ai/auth/callback',
    signOutUri: 'https://dev.kaizenic.ai', // Landing page
  },
  fullstoryOrgId: 'o-23P66J-na1',
};
